import { truncateAddress } from "@/utils";
import { useWalletConnection } from "@/hooks";

export function AccountAddress({ className, truncate = false }: { className?: string; truncate?: boolean }) {
    const { address, isConnected } = useWalletConnection();

    if (!isConnected || !address) {
        return null;
    }

    return <span className={className}>{truncate ? truncateAddress(address) : address}</span>;
}
